import React from 'react';
import { Outlet } from 'react-router-dom';
import packageJSON from '../../../package.json';
import PageHeader from '../../components/PageHeader';
import { t } from '../../lang';
import BillingHeader from '../BillingCurrency/components/BillingHeader/BillingHeader';

import './BuyBillingCurrency.scss';
import AppConfig from '../../config'

const CREDIT_CURRENCY = AppConfig?.creditCurrency ?? 'Credits';

const BuyBillingCurrency = () => {
	return (
		<div className='BuyBillingCurrency'>
			<PageHeader />
			<div className='BuyBillingCurrency__body'>
				<BillingHeader
					title={t('Buy {currency}', { currency: CREDIT_CURRENCY })}
					description={t(
						'TRON fees can be paid using {currency}, simplifying fee management for outgoing transactions.',
						{
							currency: CREDIT_CURRENCY,
						}
					)}
				/>
				<Outlet />
			</div>
		</div>
	);
};

export default BuyBillingCurrency;
